// Support-case date formatting. Matches the project's M/D/YYYY convention
// (see CLAUDE.md "Date Formatting"); never rely on Date.toString()/toISOString().

/** M/D/YYYY, e.g. 6/7/2026. Returns '' for null/invalid. */
export function formatCaseDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
}

/** M/D/YYYY, h:mm AM/PM — used on the comment thread. Returns '' for null/invalid. */
export function formatCaseDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-US', {
    month: 'numeric', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}
